
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0a294a","d":"M5.714 2.619C5.714 1.172 6.78 0 8.095 0c1.315 0 2.381 1.172 2.381 2.619V4.19h5.714v6.286h1.43c1.314 0 2.38 1.172 2.38 2.62 0 1.446-1.066 2.618-2.38 2.618h-1.43V22h-5.714v-1.571c0-1.536-1.2-2.763-2.626-2.606-1.24.137-2.136 1.385-2.136 2.755V22H0v-6.286h1.429c1.396 0 2.511-1.32 2.368-2.889-.125-1.363-1.259-2.349-2.505-2.349H0V4.19h5.714z"}})])
          )
        }
      }
    